<sbpro-layout-dashboard [light]="true">
    <router-outlet></router-outlet>
</sbpro-layout-dashboard>
